export default function imageboss ({ $config }, inject) {
  /* eslint-disable camelcase */
  function imageBossURL ({ imageSource, operation, fileName, dpr }) {
    return `https://img.imageboss.me/${imageSource}/${operation}/dpr:${dpr}/${fileName}`
  }

  const imageSources = {
    prod: 'qb-content',
    staging: 'qb-cms-homolog',
    default: 'qb-cms-homolog',
  }

  function getOperation ({ operation, width, height }) {
    const operations = {
      width: () => `width/${width}`,
      height: () => `height/${height}`,
      cdn: () => 'cdn',
      cover: () => {
        const size = `${width}x${height}`
        return `cover/${size}`
      },
    }

    return operations[operation] || operations.cover
  }

  function getCdnImagePath (fileName) {
    return `${$config.cms.cdn}/uploads/${fileName}`
  }

  function getAssetURL (src, options = {}) {
    const {
      storage,
      filename_disk,
      width: srcWidth,
      height: srcHeight,
    } = src

    if (!filename_disk) return null

    if ($config.ENVIRONMENT === 'development') return `${$config.cms.cdn}/assets/${filename_disk}`

    if (storage !== 'aws') return getCdnImagePath(filename_disk)

    const [hash, ext] = filename_disk.split('.')

    if (ext === 'svg') return getCdnImagePath(filename_disk)

    const {
      dpr = 1,
      operation = 'cover',
      width: operationWidth,
      height: operationHeight,
    } = options

    const [width, height] = [operationWidth || srcWidth, operationHeight || srcHeight]
    const fileName = `${hash}.${ext}`
    const imageSource = imageSources[$config.ENVIRONMENT] || imageSources.default
    const formattedOperation = getOperation({ operation, width, height })
    const config = { imageSource, operation: formattedOperation(), fileName, dpr }

    return imageBossURL(config)
  }

  inject('imageboss', getAssetURL)

  return getAssetURL
}
